(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller.overview
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.bar-chart.view :as bar-chart]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.lp-portal.report.overview.big-figures.controller :as big-figures]
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.component.chart.water-fall :as water-fall]))

(defn- nav-development
  [data]
  (let [[labels values] ((juxt :labels :net-asset-value-of-the-fund) data)]
    (bar-chart/bar-chart-config labels values :orientation :column)))

(defn- fund-nav-change-breakdown
  [{:keys [opening-nav
           net-subscriptions-by-redemptions
           income-distribution
           changes-in-fair-value-of-portfolio
           other-changes
           closing-nav]}]
  (water-fall/water-fall-config
   (->> [["Opening NAV" (first opening-nav)]
         ["Net Subscriptions / Redemptions" (first net-subscriptions-by-redemptions)]
         ["Income distribution" (first income-distribution)]
         ["Changes in fair value of portfolio" (first changes-in-fair-value-of-portfolio)]
         ["Other changes" (first other-changes)]
         ["Closing NAV" (first closing-nav)]]
        (map (fn [[k v]]
               {:name k
                :y    v})))))

(defn- total-return
  [data]
  (let [specs [[:three-months "3 months" util/->percent-2-decimals]
               [:ytd "YTD" util/->percent-2-decimals]
               [:twelve-months "12 months" util/->percent-2-decimals]
               [:three-years "3 years" util/->percent-2-decimals]
               [:five-years "5 years" util/->percent-2-decimals]
               [:ten-years "10 years" util/->percent-2-decimals]
               [:since-inception-p-a "Since inceptions p.a." util/->percent-2-decimals]]]
    (util/->data-for-table data specs)))

(defn- portfolio-at-market-value
  [{:keys [labels portfolio-at-market-value]}]
  (map vector labels portfolio-at-market-value))

(defn- gav-breakdown
  [{:keys [labels ifrs]}]
  (map vector labels ifrs))

(defn- market-value-by-operator
  [{:keys [labels fair-market-value-by-location]}]
  (map vector labels fair-market-value-by-location))

(defn- market-value-by-currency
  [{:keys [labels market-value-by-currency-pct]}]
  (map vector labels market-value-by-currency-pct))

(defn overview
  [{:keys [dynamic-path dynamic-data report-data map-topo] :as props}]
  {:overview-figures        (report-ctl/with-footnote
                             props
                             :overview-figures-footnotes
                             (big-figures/resi-summary-figures report-data))
   :recent-development-text (report-ctl/rich-content props :recent-development-text)
   :highlights              (report-ctl/with-footnote
                             props
                             :highlight-footnotes
                             (get-in report-data [:fund-figures]))
   :nav-development         (report-ctl/with-footnote
                             props
                             :net-development-footnotes
                             (nav-development (get-in report-data [:chart-data-nav-development])))
   :fund-nav-change-breakdown (report-ctl/with-footnote
                               props
                               :fund-nav-change-breakdown-footnotes
                               (fund-nav-change-breakdown (:chart-data-nav-development
                                                           report-data)))
   :total-return            (report-ctl/with-footnote
                             props
                             :total-return-footnotes
                             (:total-return report-data))
   :portfolio-at-market-value (report-ctl/with-footnote
                               props
                               :portfolio-at-market-value-footnotes
                               (donut-chart/donut-chart-config
                                (->> (portfolio-at-market-value
                                      (:chart-data-market-value
                                       report-data))
                                     (remove (fn [[l v]]
                                               (zero? v))))
                                {:data-label-formatter
                                 chart-utils/pie-float-label-formatter-no-division}))
   :gav-breakdown           (report-ctl/with-footnote
                             props
                             :gav-breakdown-footnotes
                             (donut-chart/donut-chart-config
                              (->> (gav-breakdown
                                    (:chart-data-gav-breakdown
                                     report-data))
                                   (remove (fn [[l v]]
                                             (zero? v))))
                              {:data-label-formatter
                               chart-utils/pie-float-label-formatter-divide-m}))
   :market-value-by-operator (report-ctl/with-footnote
                              props
                              :market-value-by-operator-footnotes
                              (donut-chart/donut-chart-config
                               (->> (market-value-by-operator
                                     (:chart-data-gav-location
                                      report-data))
                                    (remove (fn [[l v]]
                                              (zero? v))))
                               {:data-label-formatter
                                chart-utils/pie-float-label-formatter-no-division}))
   :market-value-by-currency (report-ctl/with-footnote
                              props
                              :market-value-by-currency-footnotes
                              (donut-chart/donut-chart-config
                               (->> (market-value-by-currency
                                     (:chart-data-gav-currency
                                      report-data))
                                    (remove (fn [[l v]]
                                              (zero? v))))
                               {:data-label-formatter
                                chart-utils/pie-float-label-formatter-no-division-with-%}))})
